import { t } from 'i18next'

import type { PurchasesResponse } from '@/api/@types'
import i18n from '@/lib/i18n'
import type { KeyLabel } from '@/types'

export const PURCHASE_TITLE = i18n.t('top.menu.ecOrderImport') // NOTE: 'EC注文取込結果' は暫定タイトルのため後に本来の '仕入情報' に戻す想定

export const PURCHASE_FIELDS: KeyLabel<PurchasesResponse> = {
  ecSalesOrderNo: t('purchase.fields.ecSalesOrderNo'),
  importDateTime: t('purchase.fields.importDateTime'),
  systemType: t('purchase.fields.systemType'),
  shippingDate: t('purchase.fields.shippingDate'),
  trackingNos: t('purchase.fields.trackingNos'),
  fileName: t('purchase.fields.fileName'),
  deliveryId: t('purchase.fields.deliveryId'),
  deliveryName: t('purchase.fields.deliveryName'),
  deliveryAddress: t('purchase.fields.deliveryAddress'),
  desiredDeliveryDate: t('purchase.fields.desiredDeliveryDate'),
  desiredDeliveryTime: t('purchase.fields.desiredDeliveryTime'),
  scheduledShippingDate: t('purchase.fields.scheduledShippingDate'),
  scheduledArrivalDate: t('purchase.fields.scheduledArrivalDate'),
  shippingWarehouse: t('purchase.fields.shippingWarehouse'),
  shippingCompany: t('purchase.fields.shippingCompany'),
  salesOrderNo: t('purchase.fields.salesOrderNo'),
  salesNos: t('purchase.fields.salesNos'),
}
